export default __webpack_public_path__ + "static/media/inverter.69c2f697.png";